import { formatDateFromDB } from '../../../../../utils/FormatDate';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';

const GridProviderTransport = ({ data = [], isLoading }) => {
  const columns = [
    // { field: 'zaposleni', headerName: 'Zaposleni', width: 200 },
    // { field: 'kolicina', headerName: 'Sati', width: 150 },
    // { field: 'brutoCenaTroskovi', headerName: 'Bruto cena', width: 200 },
    // { field: 'cena', headerName: 'Cena', width: 200 },
    { field: 'zaposleni', headerName: 'Zaposleni', width: 200 },
    { field: 'nazivUsluge', headerName: 'Vrsta', width: 200 },
    { field: 'jm', headerName: 'Jedinica mere', width: 120 },
    { field: 'kolicina', headerName: 'Količina', width: 80 },
    {
      field: 'brutoCenaTroskovi',
      headerName: 'Cena koštanja transporta',
      width: 200,
    },
    { field: 'cena', headerName: 'Cena prema klijentu', width: 200 },
    {
      field: 'datum',
      headerName: 'Datum',

      width: 150,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },
    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProviderTransport;
